<template>
  <div class="d-flex flex-column min-vh-100">
    <HeaderVie />
    <main class="flex-grow-1">
      <router-view />
    </main>
    <FooterVie />
  </div>
</template>

<script>
import HeaderVie from "./components/HeaderVie.vue";
import FooterVie from "./components/FooterVie.vue";

export default {
  name: "App",
  components: {
    HeaderVie,
    FooterVie,
  },
};
</script>
